/** Resolve the public seller name from any partial seller row. Never falls back to email. */
export function resolvePublicSellerName(row: {
  shop_name?: string | null;
  display_name?: string | null;
  username?: string | null;
} | null | undefined): string {
  if (!row) return "BidNova Seller";
  const shop = row.shop_name?.trim();
  if (shop) return shop;
  const display = row.display_name?.trim();
  if (display) return display;
  const u = row.username?.trim();
  if (u) return u;
  return "BidNova Seller";
}

export function resolvePublicSellerHandle(row: {
  username?: string | null;
  id?: string | null;
} | null | undefined): { to: "/seller/$sellerId"; params: { sellerId: string } } | null {
  if (!row) return null;
  const handle = row.username?.trim() || row.id?.trim();
  if (!handle) return null;
  return { to: "/seller/$sellerId", params: { sellerId: handle } };
}
